import { render, staticRenderFns } from "./staffroyaltyDetail.vue?vue&type=template&id=3fc916f9&scoped=true&"
import script from "./staffroyaltyDetail.vue?vue&type=script&lang=js&"
export * from "./staffroyaltyDetail.vue?vue&type=script&lang=js&"
import style0 from "./staffroyaltyDetail.vue?vue&type=style&index=0&id=3fc916f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc916f9",
  null
  
)

export default component.exports